module.exports = __webpack_public_path__ + "img/LU.ce54a77a.svg";